module.exports = __webpack_public_path__ + "img/dataMiddleground-charafunction4.d513b9e2.png";